const service_info = {
    "Stair cases":
        {
            title: "Stair cases",
            content: [{description: "Custom made Solid hard wood stair case ", img_urls: ["staircase_1.jpg","staircase_2.jpg", "staircase_3.jpg","staircase_4.jpg",
                    "staircase_5.jpg","staircase_6.jpg", "staircase_7.jpg","staircase_8.jpg","staircase_9.jpg"],path:"custom-made-solid-hard-wood"},

            ],
            path:"stair-cases"

        },
    "Pivot doors":
        {
            title: "Pivot doors",
            content: [
                {description:"Solid timber pivot door + smart lock", img_urls: ["pivotdoor_14.jpg","pivotdoor_15.jpg"],path:"solid-timber-pivot-smart-lock"},
                {description:"Full solid custom made pivot doors",img_urls:["pivotdoor_1.jpg",],path:"full-solid-custom-made-pivot"},
                {description:"Custom made solid timber pivot door", img_urls: ["pivot-custom-solid-1.jpg","pivot-custom-solid-2.jpg"],path:"custom-made-solid-timber-pivot"},
                {description:"Custom made jumbo pivot doors",img_urls:["pivotdoor_3.jpg", "pivotdoor_4.jpg",
                        "pivotdoor_5.jpg","pivotdoor_6.jpg","pivotdoor_9.jpg","pivotdoor_10.jpg",],path:"custom-made-jumbo-pivot"},
                {description:"Full solid pivot door & smart lock",img_urls:["pivotdoor_8.jpg",],path:"full-solid-pivot-smart-lock"},
                {description: "Luxury solid timber pivot door",img_urls: ["pivotdoor_11.jpg","pivotdoor_12.jpg","pivotdoor_13.jpg"],path:"luxury-solid-timber-pivot"}

            ],
            path:"pivot-doors"

        },
    "Entrance & Internal doors":
        {
            title: "Entrance & Internal doors",
            content: [
                {description:"Standard Entrance Door",img_urls:["entrancedoor_1.jpg", "entrancedoor_2.jpg","entrancedoor_3.jpg"],path:"standard-entrance"},
                {description:"Custom made unique design internal hollow door ",img_urls:["internal_1.jpg","internal_2.jpg"],path:"custom-made-unique-design-internal-hollow"},
                {description:"Jumbo internal door +classic lock",img_urls:["jumboInternal1.jpg", "jumboInternal2.jpg","jumboInternal3.jpg","jumboInternal4.jpg"],path:"jumbo-internal-classic-lock"},
                {description:"Flush Gyprocker door jambs, frameless finish ",img_urls:["internal_3.jpg","internal_4.jpg",],path:"flush-gyprocker-frameless"},
                {description:"Solid timber French door with crispy finish",img_urls:["entrancedoor_4.jpg","entrancedoor_5.jpg","entrancedoor_6.jpg","entrancedoor_7.jpg"],path:"solid-timber-french-crispy"},

            ],
            path:"entrance-internal-doors"

        },
    "Security doors & One way mesh privacy doors":
        {
            title: "Security doors & One way mesh privacy doors",
            content: [
                {description:"Securiy Hinge door",img_urls:["securitydoor_1.jpg","securitydoor_5.jpg","securitydoor_9.jpg",
                        "securitydoor_10.jpg","securitydoor_11.jpg","securitydoor_12.jpg","securitydoor_13.jpg","securitydoor_14.jpg"],path:"security-hinge"},
                {description:"316 stainless steel sliding security screen door",img_urls:
                        ["securitydoor_2.jpg","securitydoor_3.jpg","securitydoor_4.jpg","securitydoor_15.jpg","securitydoor_16.jpg","securitydoor_17.jpg"],path:"316-stainless-sliding-security-screen"},
                {description:"316 stainless steel screen 3 point triple locks",img_urls:
                        ["securitydoor_15.jpg","securitydoor_16.jpg","securitydoor_17.jpg"],path:"316-stainless-steel-screen-3-point-triple"},
                {description:"Double security stainless steel doors+soft closer",img_urls:
                        ["double_soft_sec_1.jpg","double_soft_sec_2.jpg","double_soft_sec_3.jpg","double_soft_sec_4.jpg",
                            "double_soft_sec_5.jpg","double_soft_sec_6.jpg","double_soft_sec_7.jpg","double_soft_sec_8.jpg"],path:"double-security-stainless-steel-soft"},
                {description:"Aluminium one way vision privacy mesh",img_urls: ["alu_oneway_1.jpg","alu_oneway_2.jpg","alu_oneway_2_inside.jpg"],path:"aluminium-one-way-vision-privacy-mesh"},
                // {description:"Aluminium hinge door",img_urls: ["alu_hinge_1.jpg","alu_hinge_2.jpg"]},
                {description:"Double side security door",img_urls:["securitydoor_6.jpg","securitydoor_7.jpg"],path:"double-side-security"},
                {description:"Stainless steel security screen door+pet door",img_urls:["securitydoor_8.jpg"],path:"stainless-steel-security-screen-pet"},

            ],
            path:"security-oneway-doors"

        },
    "Stacker doors":
        {
            title: "Stacker doors",
            content: [
                {description:"Aluminium commerical grade 150mm thickness frame, 5 tracks + security doors system",
                    img_urls:["5stacksecurity_1.jpg","5stacksecurity_2.jpg","5stacksecurity_3.jpg","stackerdoor_3.jpg","stackerdoor_4.jpg"],path:"aluminium-commercial-150mm-5-tracks-security"},
                {description:"3 Panels+5 tracks stacking door",img_urls:["stackerdoor_1.jpg"],path:"3-panels-5-tracks-stacking"},
                {description:"Triple stacking cavity slider",img_urls:["stackerdoor_2.jpg"],path:"triple-stacking-cavity"},


            ],
            path:"stacker-doors"

        },
    "Bi fold doors":
        {
            title: "Bi fold doors",
            content: [
                {description:"3 panels bi fold doors",img_urls:["bifold_1.jpg","bifold_2.jpg"],path:"3-panels-bi-fold"},
                {description:"5 panels bi fold doors",img_urls:["bifold_3.jpg","bifold_4.jpg"],path:"5-panels-bi-fold"},
                {description:"Timber bi fold door set",img_urls:["timber_bifold.jpg","timber_bifold_2.jpg","timber_bifold_3.jpg"],path:"timber-bi-fold"},
                {description: "Commercial grade 5+1bi fold door", img_urls: ["commercial-5-1-bifold-1.jpg",
                        "commercial-5-1-bifold-2.jpg",
                        "commercial-5-1-bifold-3.jpg",
                        "commercial-5-1-bifold-4.jpg"],path:"commercial-5-1-bi-fold"}

            ],
            path:"bifold-doors"

        },
    "Sliding windows":
        {
        title: "Sliding windows",
        content: [
            {description:"Commercial 100mm sliding window",img_urls:["slidingwindow_5.jpg","slidingwindow_6.jpg","slidingwindow_7.jpg"],path:"commercial-100mm-sliding-window"},
            {description:"Residential grade 67mm sliding window + timber reveal",img_urls:["slidingwindow_2.jpg","slidingwindow_3.jpg","slidingwindow_4.jpg",
                    "slidingwindow_8.jpg","slidingwindow_9.jpg","slidingwindow_10.jpg","slidingwindow_11.jpg","slidingwindow_12.jpg",],path:"residential-grade-67mm-sliding-window-timber-reveal"},
            {description:"Close off garage with commercial grade sliding window",img_urls:["slidingwindow_1.jpg"],path:"close-off-garage-commercial-sliding-window"},
            {description:"Commercial grade 100mm  sliding window",img_urls:["slidingwin_1.jpg"],path:"commercial-100mm-sliding-window"},


        ],
            path:"sliding-windows"

    },
    "Sliding doors":
        {
            title: "Sliding doors",
            content: [
                {description: "Shop front aluminium commercial grade sliding door",img_urls: ["shop_front_1.jpg","shop_front_2.jpg"],path:"shop-front-aluminium-commercial-sliding"},
                {description:"100mm commercial grade sliding door",img_urls:["slidingdoor_1.jpg","slidingdoor_2.jpg"],path:"100mm-commercial-sliding"},
                {description:"Enclosure Alfresco with commercial grade 100mm sliding door",img_urls:["slidingdoor_13.jpg","slidingdoor_14.jpg",
                        "slidingdoor_3.jpg","slidingdoor_4.jpg","slidingdoor_7.jpg","slidingdoor_8.jpg","slidingdoor_9.jpg","slidingdoor_10.jpg","slidingdoor_15.jpg","slidingdoor_16.jpg",
                        "slidingdoor_17.jpg","slidingdoor_18.jpg","slidingdoor_19.jpg","slidingdoor_20.jpg","slidingdoor_21.jpg",]
                    ,path:"enclosure-alfresco-commercial-100mm-sliding"},
                {description:"Enclosure alfresco with aluminium commercial grade 100mm Jumbo siding door+stainless steel security door",img_urls:["slidingdoor_11.jpg","slidingdoor_12.jpg"]
                    ,path:"enclosure-alfresco-aluminum-commercial-100mm-jumbo-sliding-stainless-steel-security"},
                {description:"Double cavity sliders",img_urls:["sliderdoor1.jpg"],path:"double-cavity-sliders"},
                {description:"sliding door-garage sliding door",img_urls:["slidingdoor_5.jpg","slidingdoor_6.jpg"],path:"garage-sliding"},
                {description: "Alfresco with commercial grade materials+6.38mm glazing.",img_urls: ["alfresco_1.jpg"
                        ,"alfresco_2.jpg","alfresco_3.jpg","alfresco_4.jpg","alfresco_5.jpg","alfresco_6.jpg"],path:"alfresco-commercial-materials-six-point-thirty-eight-mm-glazing"}

            ],
            path:"sliding-doors"

        },
    "Shop front doors":
        {
            title: "Shop front doors",
            content: [

                {description: "Aluminium commercial grade sliding door",img_urls: ["shop_front_1.jpg"],path:"aluminium-commercial-sliding"},
                {description: "Double side hinge doors",img_urls: ["double_hinge_1.jpg","shop_front_3.jpg","shop_front_4.jpg","shop_front_5.jpg"],path:"double-side-hinge"},
                {description: "Custom made hinge door",img_urls: ["shop_front_2.jpg","shop_front_6.jpg","shop_front_7.jpg"],path:"custom-made-hinge"},

            ],
            path:"shop-front-doors"

        },
    "Double glazing windows":
        {
            title: "Double glazing windows",
            content: [
                {description: "Double glazing window: 6mm clear toughened+6mm air+6mm clear toughened",img_urls:["double_glazing_window_1.jpg","double_glazing_window_3.jpg","double_glazing_window_4.jpg","double_glazing_window_5.jpg"]
                    ,path:"6mm-clear-toughen-6mm-air-6mm-clear-toughened"},
                {description: "Double glazing window+ Architraves",img_urls:["double_glazing_window_2.jpg"],path:"double-glazing-architraves"},
            ],
            path:"double-glazing-windows"
        },

    "Cladding and decking":
        {
            title: "Cladding and decking",
            content: [
                {description: "Cladding and Decking",img_urls:["cladding-decking_1.jpg","cladding-decking_2.jpg"]},
            ],
            path:"cladding-decking"
        }




}

export default service_info;

